@import '../../constants/spacing.module.less';

.container {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: @space-16 @space-8;
  align-items: center;
  font-size: 14px;

  > *:nth-child(2n) {
    justify-self: end;
  }
}

.total-amount {
  font-weight: 500;
}

.surcharge-label {
  display: flex;
  align-items: center;
  gap: @space-8;
}
